import { withInstall } from '../../utils';
import LivePlayer from './src/live-player.vue';

export const ILivePlayer = withInstall(LivePlayer); // 增加类型

export default ILivePlayer;
